let Layouts = {};

Layouts['Layout'] = require('./Layout').default;
Layouts['Layout1'] = require('./Layout1').default;

export {
    Layouts
};